import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import investigatorImage from '../../../Assets/ResearchLabs/GSAGL/Director/GSAGL-Director.png';

const { Link, Text, Title } = Typography;

const PrincipalInvestigator = () => (
  <section className="principal-investigator-section">
    <div className="investigator-content">
      <Title level={2} className="investigator-title">Principal Investigator/Lab Director</Title>
      <Divider className="ncgsa-divider" />
      <img className="investigator-photo" src={investigatorImage} alt="Dr. Muhammad Shafique" />
      <Text strong className="investigator-name">Dr. Muhammad Shafique</Text>
      <Text className="investigator-affiliation">University of Peshawar</Text>
      <Link className="investigator-contact" href="mailto:shafique@uop.edu.pk">shafique@uop.edu.pk</Link>
      <Link className="investigator-contact" href="tel:+92919216427">Phone: 091-9216427</Link>
    </div>
  </section>
);

export default PrincipalInvestigator;
